export const grossPriceVisibilityOptions = [
  {
    value: true,
    label: 'Visible',
  },
  {
    value: false,
    label: 'Hidden',
  },
];
